export default __webpack_public_path__ + "static/media/gallery_11.1e0e161e.jpg";